import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { CustomAuthServiceService } from '../../../auth/custom-auth-service.service';
import { AppScreen, NavigationScreensService } from '../../../manageb/navigation-screens.service';


@Component({
  selector: 'app-options-menu',
  template: `
    <div class="menu-container">
      <div class="dots" (click)="toggleMenu()">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="dropdown-menu" [class.show]="isMenuOpen">
        <a *ngFor="let item of menu" (click)="onMenuItemClicked(item)">{{item.title}}</a>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      color: #ffffff;
      position: relative;
    }

    .menu-container {
      position: relative;
    }

    .dots {
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: relative;
      transition: transform 0.3s;
       z-index: 2000;
    }

    .dots:hover {
      transform: rotate(90deg);
    }

    .dots span {
      width: 6px;
      height: 6px;
      background-color: #0E6975;
      border-radius: 50%;
      display: block;
      margin: 2px 1px;
    }


 .dropdown-menu {
  display: none;
  position: absolute;
  top: 40px;
  left: -165px;
  background-color: #ffffff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow-y: auto; 
  overflow-x: hidden;          
  max-height: 90vh;         
  z-index: 1000;
  animation: fadeIn 0.3s ease-in-out;
  width: 200px;
}

/*@media (max-width: 768px) {
  .dropdown-menu {
    position: fixed;
    top: 0;
    right: 0;
    left: auto;

    height: 100vh;
    max-height: 100vh;

    width: 70vw;
    max-width: 320px;

    overflow-y: auto;

    border-radius: 0;
    box-shadow: -4px 0 12px rgba(0, 0, 0, 0.15);
  }
}*/
@media (max-width: 768px) {
  .dropdown-menu {
    position: fixed;
    top: 0;
    right: 0;
    left: auto;

    height: 100vh;
    width: 70vw;
    max-width: 320px;

    overflow-y: auto;

    border-radius: 0;
    box-shadow: -4px 0 12px rgba(0, 0, 0, 0.15);
    z-index: 1500;
  }

  .dots {
    position: fixed;
    top: 16px;
    right: 16px;
    z-index: 2000;
  }
}





    .dropdown-menu.show {
      display: block;
    }

    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(-10px); }
      to { opacity: 1; transform: translateY(0); }
    }

    .dropdown-menu a {
      display: block;
      padding: 12px 20px;
      text-decoration: none;
      color: #333;
      font-size: 16px;
      transition: background-color 0.3s, padding-left 0.3s;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
      @media (max-width: 1280px) {
  .dropdown-menu a {
    font-size: 13px; 
  }
}

    .dropdown-menu a:hover {
      background-color: #007bff;
      color: white;
      padding-left: 30px;
    }

    .dropdown-menu a:not(:last-child) {
      border-bottom: 1px solid #e0e0e0;
    }
  `]
})
export class OptionsMenuComponent {
  isMenuOpen = false;
  menu: AppScreen[] = [];

  constructor(
    private route: Router,
    private loginService: CustomAuthServiceService,
    private screens: NavigationScreensService,
  ) {}

  toggleMenu() {
    // Effective, not primary: an impersonating admin gets the menu of the role
    // they contact as, which is the same role the route guards enforce.
    const role = this.loginService.effectiveRoleOf(this.loginService.currentUserValue());
    this.menu = this.screens.getScreensForRole(role);
    this.isMenuOpen = !this.isMenuOpen;
  }

  onMenuItemClicked(item: AppScreen) {
    if (item.title === 'Log Out') {
      this.loginService.goToLogin(undefined, false); // voluntary logout — don't restore last page
      return;
    }
    if (!item.path) {
      return;
    }
    this.route.navigate([item.path], item.state ? { state: item.state } : {});
  }

  @HostListener('window:click', ['$event'])
  onWindowClick(event: Event) {
    if (!(event.target as HTMLElement).closest('.dots')) {
      this.isMenuOpen = false;

    }
  }
}